import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PanelSubHeading from "../../components/panel/subHeading";
import ProgressBar from "./charts/progressBar";
import { backend, Dates, HireStats, statsBackend } from "../../services";
import { actions, RootState } from "../../state/reducer";
import { generateRandomString, getMonthAndYear } from "../../utils";
import { UserShortInfo } from "../../types";
import { closeModal, openModal } from "../../state/modalSlice";
import SelectFunnelModal from "../../modals/stats/funnelSelect";
import { FilterIcon } from "../../icons/filter";
import ProgressBarPeople from "./charts/progressBarPeople";

const usingCurrencyId = 1;

const demoHirePlan = 5000;

const demoCounts = {
   employ: 0,
   unemploy: 0,
   updated: 0
}

const HireRatingDiagram = (props: {
  userId?: number;
  dates?: Dates;
  enableSettings?: boolean;
  userInfo?: UserShortInfo;
}) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [saleAmount, setSaleAmount] = useState<number>(0);
  const [salePlan, setSalePlan] = useState<number>(demoHirePlan);
  const [hireStats, setHireStats] = useState<HireStats>(demoCounts)
  const user_id = props?.userId || State.session?.id;
  const dates = props.dates || getMonthAndYear(new Date());

  if (!user_id) {
    return null;
  }

  // Получаем текущий месяц и год
  const today = new Date();
  const monthNames = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];
  const currentMonth = monthNames[today.getMonth()]; // Название текущего месяца
  const currentYear = today.getFullYear(); // Текущий год

  useEffect(() => {
    statsBackend.getHireStats({}).then((res) => {
      console.log("Hire stats:", res)
      setHireStats(res.data)
    })
  }, [])

  const handleOpenFilters = () => {
    dispatch(
      openModal({
        component: SelectFunnelModal,
        context: {
          onSave: () => {
            console.log("Save");
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  if (!salePlan) {
    return null;
  }

  return (
    <div
      className="panel eventListPanel"
      style={
        !props.enableSettings
          ? {
              width: "calc(100% - 32px)",
            }
          : {
              width: "100%",
              marginBottom: 16,
            }
      }
    >
      <div className="inner">
        <div className="flex between w100">
          <PanelSubHeading text="Рейтинг найма сотрудников" />
          {props.enableSettings && (
            <div className="btn filterBtn" onClick={handleOpenFilters}>
              <FilterIcon width={20} height={20} />
            </div>
          )}
        </div>
        <div className="toDoHeadingBorder" style={{ marginTop: 6 }} />
        <div className="inner">
          <div className="flex between">
            <div className="text">
              {` Всего - ${Number(hireStats.employ) + Number(hireStats.unemploy) + Number(hireStats.updated)} человек`}
            </div>
            <div className="eventDateInfo">
              План на период - {currentMonth} {currentYear}
            </div>
          </div>
          <ProgressBarPeople
            fact={saleAmount}
            {...hireStats}
          />
        </div>
      </div>
    </div>
  );
};

export default HireRatingDiagram;
